export function buildCampaignPayload(data, flow) {
    const payload = {
        workspaceId: data.workspace?.value,
        name: data.name.trim(),
        trafficID: data.trafficSource?.value || 0,
        trackingDomainId: data.trackingDomain?.value || 0,
        cloakingDomainId: data.redirectMode === 'doubleMeta' ? data.cloakingDomain?.value || 0 : 0,
        countryCode: data.country?.code || '',
        currencyCode: data.currency?.code || '',
        costModel: data.costModel,
        costValue: Number(data.costValue) || 0,
        conversionActionId: data.conversionAction?.id || 0,
        conversionPixelId: data.conversionPixel?.id || 0,
        destinationType: data.destinationType,
        destinationUrl: data.destinationType === 'url' ? data.destinationUrl : '',
        redirectMode: data.redirectMode,
        tags: data.tags || [],
        flow: data.destinationType === 'sharedFlow' ? null : flow
    };
    if (data.destinationType === 'sharedFlow') payload.flowId = data.sharedFlow?.value;
    return payload;
}

export function getCampaignFlowIssues(flow) {
    const issues = [];
    const validWeight = value => value !== '' && value != null && Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100;
    for (const [ruleIndex, rule] of (flow?.rules || []).entries()) {
        const ruleLabel = ruleIndex === 0 ? 'Default' : rule.name?.trim() || `Rule ${ruleIndex}`;
        if (ruleIndex > 0 && !rule.name?.trim()) issues.push({ruleIndex, field: `rules.${ruleIndex}.name`, message: `Rule ${ruleIndex}: Enter a rule name.`});
        for (const [pathIndex, path] of (rule.paths || []).entries()) {
            const prefix = `rules.${ruleIndex}.paths.${pathIndex}`;
            const location = `${ruleLabel} → ${path.name?.trim() || `Path ${pathIndex + 1}`}`;
            const add = (field, message, itemIndex) => issues.push({ruleIndex, pathIndex, itemIndex, field: `${prefix}.${field}`, message: `${location}: ${message}`});
            if (!path.name?.trim()) add('name', 'Enter a path name.');
            if (!validWeight(path.weight)) add('weight', 'Use whole-number weights from 0 to 100.');
            for (const type of path.directLinking ? ['offer'] : ['landing', 'offer']) {
                const items = path[`${type}s`] || [];
                if (!items.length) add(`${type}s.0.id`, `Choose at least one ${type}.`, 0);
                for (const [index, item] of items.entries()) {
                    if (!(item[`${type}Id`] > 0)) add(`${type}s.${index}.id`, `Choose ${type === 'offer' ? 'an offer' : 'a landing'} for row ${index + 1}.`, index);
                    if (!validWeight(item.weight)) add(`${type}s.${index}.weight`, `Use whole-number weights from 0 to 100 for ${type} row ${index + 1}.`, index);
                }
            }
        }
    }
    return issues;
}

export function getCampaignRequestError(failure, fallback) {
    const messages = value => {
        if (typeof value === 'string') return value.trim();
        if (Array.isArray(value)) return value.map(messages).filter(Boolean).join(' ');
        if (value && typeof value === 'object') {
            if (value.message) return messages(value.message);
            return Object.entries(value).map(([key, item]) => {
                const message = messages(item);
                return message ? `${key}: ${message}` : '';
            }).filter(Boolean).join(' ');
        }
        return '';
    };
    const data = failure?.response?.data;
    return messages(data?.error || data?.errors || data?.message) || fallback;
}
